import React, { Component } from 'react'
import { withStyles, Button, Card, CardContent, CardHeader, Avatar, CardActions, Typography, CircularProgress } from '@material-ui/core';
import { blue, orange, grey } from '@material-ui/core/colors';
import PreviewForm from '../View/PreviewForm';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import CallToAction from '@material-ui/icons/CallToAction'
import { GetData } from '../../../api/service';
import AlertDiv from './AlertDiv';
import Loading from './Loading';

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '60vh',
        alignItems: 'center',
        justifyContent: 'center'
    },
    redStrip: {
        width: '100%',
        height: 8,
        backgroundColor: blue[400]
    }
})

class PaymentGo extends Component {

    state = {
        msg: '',
        link: '',
        amount: '',
        isLoaded: false
    }

    componentDidMount() {
        // get the payment data now

        GetData(`/${this.props.email}/admissionform/haspaymentdone`)
        .then((resp) => {
            if(!resp){
                GetData(`/${this.props.email}/getemaildata`)
                    .then((resp) => {
                        //console.log(resp);
                        if (resp.hasOwnProperty('msg') && resp.hasOwnProperty('link')) {
                            this.setState({
                                msg: resp.msg,
                                link: resp.link,
                                amount: resp.amount,
                                isLoaded: true
                            })
                        }

                    })
            }else{
                this.props.history.replace('/repaymentresponse');
            }
        })

        
    }





    render() {
        let { classes } = this.props;

        return (
            <div >

                <Card>
                    <CardHeader

                        title={`Payment Page`}
                        subheader={`Click "PROCEED TO PAY" Button to continue`}
                    />

                    <CardContent>

                        {this.state.isLoaded ? (<form method="post" action={this.state.link}>

                            <AlertDiv
                                back={orange[100]}
                                border={orange[400]}
                            >
                                <Typography
                                    variant="body2"
                                >
                                    You will now redirected to the payment page. Please note the following points:
                                </Typography>
                                <ul>
                                    <li>
                                        <Typography>
                                            Follow the payment procedure very carefully
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography>
                                            After a successful payment, an online fees payment receipt will be generated
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography>
                                            You can print and save the Online application form after the payment
                                        </Typography>
                                    </li>

                                    <li>
                                        <Typography>
                                            Proceed the <b>"PROCEED TO PAY"</b> Button to continue
                                        </Typography>
                                    </li>
                                </ul>
                            </AlertDiv>


                            <input hidden name="msg" value={this.state.msg} />
                            <Button
                                variant="contained"
                                size="sm"
                                color="primary"
                                type="submit"
                            >
                                <CallToAction /> &nbsp; Proceed To Pay &#8377; {this.state.amount}
                        </Button>
                        </form>) : (
                                <Loading />
                        )}



                    </CardContent>


                </Card>
            </div>
        )
    }
}

export default withStyles(styles)(PaymentGo)


// WEBPACK FOOTER //
// ./src/Components/ReRegistration/Forms/PaymentGo.js